import React, { useState, useEffect } from 'react';
import './ConceptMatchingGame.styles.sass';

function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

function ConceptMatchingGame({ conceptsData, meaningsData }) {
  const [shuffledConcepts, setShuffledConcepts] = useState([]);
  const [shuffledMeanings, setShuffledMeanings] = useState([]);
  // Ordem fixa dos chips (mobile) — shuffledConcepts é reordenado a cada acerto pra
  // alinhar com a linha do significado (layout desktop); os chips não devem "pular".
  const [conceptChips, setConceptChips] = useState([]);
  const [matchedConcepts, setMatchedConcepts] = useState({});
  // Toque em vez de arrastar: o drag nativo do HTML5 não funciona em touch (iOS Safari
  // não dispara dragstart/drop por toque), então o jogo travava no celular.
  const [selectedConcept, setSelectedConcept] = useState(null);
  const [showCongrats, setShowCongrats] = useState(false);
  const [shakeConcept, setShakeConcept] = useState(null);

  useEffect(() => {
    // Shuffle concepts and meanings when the component mounts
    const shuffled = shuffleArray([...conceptsData]);
    setShuffledConcepts(shuffled);
    setConceptChips(shuffled);
    setShuffledMeanings(shuffleArray([...meaningsData]));
  }, []);

  const handleSelectConcept = conceptId => {
    setSelectedConcept(current => (current === conceptId ? null : conceptId));
  };

  const handleSelectMeaning = meaningId => {
    if (!selectedConcept) return;

    if (selectedConcept === meaningId) {
      // Correct match: swap positions so concept and meaning land on the same row
      const conceptIndex = shuffledConcepts.findIndex(concept => concept.id === selectedConcept);
      const meaningIndex = shuffledMeanings.findIndex(meaning => meaning.id === meaningId);

      const newShuffledConcepts = [...shuffledConcepts];
      const temp = newShuffledConcepts[meaningIndex];
      newShuffledConcepts[meaningIndex] = newShuffledConcepts[conceptIndex];
      newShuffledConcepts[conceptIndex] = temp;

      setShuffledConcepts(newShuffledConcepts);
      setMatchedConcepts(prev => ({ ...prev, [selectedConcept]: true }));
    } else {
      setShakeConcept(selectedConcept);
      setTimeout(() => setShakeConcept(null), 500);
    }

    setSelectedConcept(null);
  };

  useEffect(() => {
    if (Object.keys(matchedConcepts).length === conceptsData.length) {
      setShowCongrats(true);
    }
  }, [matchedConcepts]);

  return (
    <div className="game-container">
      <div className="instructions mb-1 rounded-xl border border-solid border-neutral-100 bg-white px-4 py-2.5 font-semibold text-primary-dark shadow-card">Toque em um conceito e depois no significado correspondente</div>

      {/* Mobile: conceitos agrupados em chips compactos (evita empilhar 2 linhas por par) */}
      <div className="concept-chip-row">
        {conceptChips.map(concept => {
          const matched = matchedConcepts[concept.id];
          return (
            <button
              key={concept.id}
              type="button"
              className={`concept-chip ${shakeConcept === concept.id ? 'shake flash-red' : ''} ${matched ? 'concept-chip--matching' : ''} ${selectedConcept === concept.id ? 'concept-chip--selected' : ''}`}
              disabled={matched}
              onClick={() => handleSelectConcept(concept.id)}
            >
              {concept.name}
            </button>
          );
        })}
      </div>

      <div className="game-content">
        {shuffledMeanings.map((meaning, index) => {
          const concept = shuffledConcepts[index];
          const matched = matchedConcepts[concept.id];
          return (
            <div
              key={meaning.id}
              className={matched ? 'concept-meaning-row concept-meaning-row--matching' : 'concept-meaning-row'}
            >
              <span className="concept-meaning-number">{index + 1}</span>
              <div className="concept-wrapper">
                <button
                  type="button"
                  className={`draggable ${shakeConcept === concept.id ? 'shake flash-red' : ''} ${matched ? 'draggable--matching' : ''} ${selectedConcept === concept.id ? 'draggable--selected' : ''}`}
                  disabled={matched}
                  onClick={() => handleSelectConcept(concept.id)}
                >
                  <p>{concept.name}</p>
                </button>
              </div>
              <button
                type="button"
                className={`droppable ${matched ? 'droppable--matching' : ''} ${selectedConcept && !matched ? 'droppable--targetable' : ''}`}
                disabled={matched}
                onClick={() => handleSelectMeaning(meaning.id)}
              >
                {meaning.meaning}
              </button>
            </div>
          );
        })}
      </div>
      {showCongrats && <div className="congrats-message">Parabéns! Você conectou todos os conceitos corretamente!</div>}
    </div>
  );
}

export default ConceptMatchingGame;
